export default
{
	"arm": {
		"jung": [
			{
				"dachzeile": "FINANZBERATER GIBT TIPPS",
				"titel": "Wie wird man reich, Herr Looman?",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/finanzberater-gibt-tipps-wie-wird-man-reich-15985412.html",
				"bild": "1.7016399"
			},
			{
				"dachzeile": "RICHTIG SPAREN",
				"titel": "Reich werden - mit nur 25 Euro",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/richtig-sparen-schon-mit-kleingeld-laesst-sich-vermoegen-aufbauen-15267968.html",
				"bild": "1.5267984"
			},
			{
				"dachzeile": "DIE BESTE VORSORGE",
				"titel": "Arbeit und Sparen sind wichtiger als Zinsen und Prämien",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/versichern-und-schuetzen/looman-arbeit-und-sparen-sind-wichtiger-als-zinsen-und-praemien-16410687.html?premium",
				"bild": "1.6411052"
			}
		],
		"mittel": [
			{
				"dachzeile": "RICHTIG SPAREN",
				"titel": "Reich werden - mit nur 25 Euro",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/richtig-sparen-schon-mit-kleingeld-laesst-sich-vermoegen-aufbauen-15267968.html",
				"bild": "1.5267984"
			},
			{
				"dachzeile": "DIE VERMÖGENSFRAGE",
				"titel": "Wird Mutter zum Pflegefall, droht der Verlust des Hauses",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/vermoegensfragen/wird-man-zum-pflegefall-kann-der-verlust-des-hauses-drohen-16304321.html",
				"bild": "1.6304949"
			},
			{
				"dachzeile": "GELDANLAGE",
				"titel": "Beton auf Pump - oder doch Aktien?",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/geldanlage-investitionen-in-immobilien-und-aktien-16591781.html",
				"bild": "1.6591830"
			}
		],
		"alt": [
			{
				"dachzeile": "RICHTIG SPAREN",
				"titel": "Reich werden - mit nur 25 Euro",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/richtig-sparen-schon-mit-kleingeld-laesst-sich-vermoegen-aufbauen-15267968.html",
				"bild": "1.5267984"
			},
			{
				"dachzeile": "KOSTEN FÜR DIE GESUNDHEIT",
				"titel": "So gelingt die Flucht aus der teuren Krankenversicherung ",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/so-gelingt-die-flucht-aus-der-teuren-krankenversicherung-16925467.html",
				"bild": "1.6925532"
			},
			{
				"dachzeile": "DIE VERMÖGENSFRAGE",
				"titel": "Wird Mutter zum Pflegefall, droht der Verlust des Hauses",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/vermoegensfragen/wird-man-zum-pflegefall-kann-der-verlust-des-hauses-drohen-16304321.html",
				"bild": "1.6304949"
			}
		]
	},
	"mittel": {
		"jung": [
			{
				"dachzeile": "FINANZBERATER GIBT TIPPS",
				"titel": "Wie wird man reich, Herr Looman?",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/finanzberater-gibt-tipps-wie-wird-man-reich-15985412.html",
				"bild": "1.7016399"
			},
			{
				"dachzeile": "NACHHILFE FÜR JUNGE LEUTE",
				"titel": "Geld anlegen wie die Reichen",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/vermoegensfragen/nachhilfe-fuer-junge-leute-geld-anlegen-wie-die-reichen-16927211.html",
				"bild": "1.6927351"
			},
			{
				"dachzeile": "IMMOBILIENKAUF 1988 UND HEUTE",
				"titel": "Jung, gutverdienend und kein Haus",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/mieten-und-wohnen/ein-generationsvergleich-hauskauf-1988-und-heute-15964460.html",
				"bild": "1.5964465"
			}
		],
		"mittel": [
			{
				"dachzeile": "NACHTEILE EINER FRÜHEREN RENTE",
				"titel": "Arm ins Leben oder reich in Rente?",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/vorsorgen-fuer-das-alter/nachteile-einer-fruehen-rente-arm-ins-leben-oder-reich-in-rente-16764975.html",
				"bild": "1.6765073"
			},
			{
				"dachzeile": "GELASSENHEIT AN DER BÖRSE",
				"titel": "Die unsinnige Angst vor Verlusten",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/warum-verlustaengste-an-der-boerse-unsinnig-sind-16671377.html",
				"bild": "1.6671379"
			},
			{
				"dachzeile": "DIE VERMÖGENSFRAGE",
				"titel": "Wird Mutter zum Pflegefall, droht der Verlust des Hauses",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/vermoegensfragen/wird-man-zum-pflegefall-kann-der-verlust-des-hauses-drohen-16304321.html",
				"bild": "1.6304949"
			}
		],
		"alt": [
			{
				"dachzeile": "EIN PLAN UND ETWAS MUT",
				"titel": "Das ruhige Depot für kleine Millionäre",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/plan-fuer-kleine-millionaere-wie-jeder-richtig-geld-anlegen-kann-16173852.html",
				"bild": "1.6174231"
			},
			{
				"dachzeile": "GELASSENHEIT AN DER BÖRSE",
				"titel": "Die unsinnige Angst vor Verlusten",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/warum-verlustaengste-an-der-boerse-unsinnig-sind-16671377.html",
				"bild": "1.6671379"
			},
			{
				"dachzeile": "KOSTEN FÜR DIE GESUNDHEIT",
				"titel": "So gelingt die Flucht aus der teuren Krankenversicherung ",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/so-gelingt-die-flucht-aus-der-teuren-krankenversicherung-16925467.html",
				"bild": "1.6925532"
			}
		]
	},
	"reich": {
		"jung": [
			{
				"dachzeile": "DIE VERLORENEN JAHRE",
				"titel": "Was Gutverdiener finanziell oft falsch machen",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/was-gutverdiener-finanziell-oft-falsch-machen-16785640.html",
				"bild": "1.6785929"
			},
			{
				"dachzeile": "APPS UM GELD ZU SPAREN",
				"titel": "So kann jeder nebenbei investieren, ohne es zu merken",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/apps-um-geld-zu-sparen-lohnt-sich-das-15969270.html",
				"bild": "1.5971963"
			},
			{
				"dachzeile": "REICH WERDEN MIT AKTIEN",
				"titel": "Die Weisheit der Börsen-Oma",
				"url": "https://www.faz.net/aktuell/finanzen/finanzmarkt/boersen-oma-beate-sander-ist-zweifache-millionaerin-16556049.html",
				"bild": "1.6556215"
			}
		],
		"mittel": [
			{
				"dachzeile": "DIE VERLORENEN JAHRE",
				"titel": "Was Gutverdiener finanziell oft falsch machen",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/was-gutverdiener-finanziell-oft-falsch-machen-16785640.html",
				"bild": "1.6785929"
			},
			{
				"dachzeile": "EIN PLAN UND ETWAS MUT",
				"titel": "Das ruhige Depot für kleine Millionäre",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/plan-fuer-kleine-millionaere-wie-jeder-richtig-geld-anlegen-kann-16173852.html",
				"bild": "1.6174231"
			},
			{
				"dachzeile": "REICH WERDEN MIT AKTIEN",
				"titel": "Die Weisheit der Börsen-Oma",
				"url": "https://www.faz.net/aktuell/finanzen/finanzmarkt/boersen-oma-beate-sander-ist-zweifache-millionaerin-16556049.html",
				"bild": "1.6556215"
			}
		],
		"alt": [
			{
				"dachzeile": "TIPPS ZUM GELDVERMEHREN",
				"titel": "Die beste Anlagestrategie seit 1800",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/die-beste-anlagestrategie-seit-1800-16248950.html",
				"bild": "1.6248967"
			},
			{
				"dachzeile": "EIN PLAN UND ETWAS MUT",
				"titel": "Das ruhige Depot für kleine Millionäre",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/plan-fuer-kleine-millionaere-wie-jeder-richtig-geld-anlegen-kann-16173852.html",
				"bild": "1.6174231"
			},
			{
				"dachzeile": "VERSCHENKTE GEWINNMITNAHMEN",
				"titel": "Jetzt Ihre Immobilie verkaufen",
				"url": "https://www.faz.net/aktuell/finanzen/meine-finanzen/sparen-und-geld-anlegen/warum-sie-ihre-immobilie-jetzt-mit-gewinn-verkaufen-sollten-16733724.html",
				"bild": "1.6734084"
			}
		]
	}
}